/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Features_Live_LeadInputs */

const en_features_live_lead = /** @type {(inputs: Features_Live_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Coached training, live.`)
};

const pl_features_live_lead = /** @type {(inputs: Features_Live_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trening z trenerem, na żywo.`)
};

/**
* | output |
* | --- |
* | "Coached training, live." |
*
* @param {Features_Live_LeadInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const features_live_lead = /** @type {((inputs?: Features_Live_LeadInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Features_Live_LeadInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_features_live_lead(inputs)
	return en_features_live_lead(inputs)
});